import { render, staticRenderFns } from "./ModattaSideModalPaymentPix.vue?vue&type=template&id=6cf8ee70"
import script from "./ModattaSideModalPaymentPix.vue?vue&type=script&lang=js"
export * from "./ModattaSideModalPaymentPix.vue?vue&type=script&lang=js"
import style0 from "./ModattaSideModalPaymentPix.vue?vue&type=style&index=0&id=6cf8ee70&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports